<div class="page teacher-announcements-page">
  <div class="page-header">
    <div>
      <h1>{{ 'ANNOUNCEMENTS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'ANNOUNCEMENTS.TEACHER_SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="empty-state card" *ngIf="loading">{{ 'ANNOUNCEMENTS.LOADING' | translate }}</div>

  <div class="announcement-carousel-wrap" *ngIf="!loading && currentAnnouncement; else emptyAnnouncements">
    <button
      type="button"
      class="carousel-nav carousel-nav-prev"
      *ngIf="hasMultipleAnnouncements"
      (click)="previousAnnouncement()"
      [attr.aria-label]="'ANNOUNCEMENTS.PREVIOUS' | translate"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <article class="announcement-card">
      <header class="announcement-card-header">
        <div class="announcement-card-title">
          <mat-icon aria-hidden="true">campaign</mat-icon>
          <span>{{ 'ANNOUNCEMENTS.SINGLE' | translate }}</span>
          <span class="announcement-counter" *ngIf="hasMultipleAnnouncements">
            {{ currentIndex + 1 }} / {{ items.length }}
          </span>
        </div>
      </header>
      <div class="announcement-card-body">
        <p>{{ currentAnnouncement.text }}</p>
      </div>
      <footer class="announcement-carousel-footer" *ngIf="hasMultipleAnnouncements">
        <div class="carousel-dots">
          <button
            type="button"
            class="carousel-dot"
            *ngFor="let item of items; let i = index"
            [class.active]="i === currentIndex"
            (click)="goToAnnouncement(i)"
            [attr.aria-label]="('ANNOUNCEMENTS.GO_TO' | translate) + ' ' + (i + 1)"
          ></button>
        </div>
      </footer>
    </article>

    <button
      type="button"
      class="carousel-nav carousel-nav-next"
      *ngIf="hasMultipleAnnouncements"
      (click)="nextAnnouncement()"
      [attr.aria-label]="'ANNOUNCEMENTS.NEXT' | translate"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <ng-template #emptyAnnouncements>
    <div class="empty-state card" *ngIf="!loading">{{ 'ANNOUNCEMENTS.TEACHER_EMPTY' | translate }}</div>
  </ng-template>
</div>
